"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleLocalhostToken = exports.handleLocalhostAction = exports.makeLocalhostRedirectUrl = exports.isLocalhostRedirect = exports.getLocalhostBaseUrl = void 0;
var redirect_1 = require("../../build-babel/redirect/redirect");
var token_1 = require("../../build-babel/token");
var session_1 = require("../../build-babel/session");
var LOCALHOST_BASE_URL = 'https://localhost:8080';
var getLocalhostBaseUrl = function getLocalhostBaseUrl() {
  return LOCALHOST_BASE_URL;
};
exports.getLocalhostBaseUrl = getLocalhostBaseUrl;
var isLocalhostRedirect = function isLocalhostRedirect(redirectUrl) {
  return redirectUrl === LOCALHOST_BASE_URL;
};
exports.isLocalhostRedirect = isLocalhostRedirect;
var makeLocalhostRedirectUrl = function makeLocalhostRedirectUrl(idToken) {
  return "".concat(LOCALHOST_BASE_URL, "/auth?token=").concat(idToken);
};
exports.makeLocalhostRedirectUrl = makeLocalhostRedirectUrl;
var handleLocalhostAction = function handleLocalhostAction(action, env) {
  // redirect from localhost to proper login \ logout page
  var urlDomain = env === 'qa' ? 'wwwtest.hapag-lloyd.com' : 'wwwdeve.hapag-lloyd.com';
  if ('login' === action) {
    (0, redirect_1.makeRedirectTo)("https://".concat(urlDomain, "/solutions/auth/login.html?redirect_url=").concat(encodeURIComponent(LOCALHOST_BASE_URL)));
  } else if ('logout' === action) {
    (0, redirect_1.makeRedirectTo)("https://".concat(urlDomain, "/solutions/auth/logout.html?redirect_url=").concat(encodeURIComponent("".concat(LOCALHOST_BASE_URL, "/auth"))));
  }
};
exports.handleLocalhostAction = handleLocalhostAction;
var handleLocalhostToken = function handleLocalhostToken(token) {
  if (token && (0, token_1.isJTWToken)(token)) {
    (0, session_1.setSession)(token, LOCALHOST_BASE_URL);
  } else {
    (0, session_1.removeSession)(LOCALHOST_BASE_URL);
  }
};
exports.handleLocalhostToken = handleLocalhostToken;
//# sourceMappingURL=localhost.js.map